import useTranslate from '../../../../i18n/useTranslate'
const useI18nPlayground = () => {
    const translate = useTranslate()
    const handleClickChangeLang = () => {
        const thLang = translate.languageStore.currentLanguage !== translate.languageKey.th
        if (thLang) {
            translate.setChangeLanguage(translate.languageKey.th)
        } else {
            translate.setChangeLanguage(translate.languageKey.en)
        }
    }
    return {
        isTH: translate.languageStore.currentLanguage === translate.languageKey.th,
        onClickChangeLang: handleClickChangeLang,
    }
}

export default useI18nPlayground
